// core
import React, { useState } from 'react'
// assets
import euProjectPartnesLogo from 'assets/images/logos/eu_project_partners.png'
// libraries
import cx from 'classnames'
// components
import { Icon } from 'components/Icon/Icon'
import { ScrollBar } from 'components/ScrollBar/ScrollBar'
import { Layout } from 'layouts/Layout'
// styles
import css from './Partnerships.module.scss'
// trans
import { translate } from 'i18n'

export default function Partnerships() {
  const [shouldAnimateFooter, setShouldAnimateFooter] = useState<boolean>(true)

  return (
    <Layout hideBackdrop footerAnimate={shouldAnimateFooter}>
      <div className={cx('container', css.root)}>
        <section className="d-flex justify-content-center mx-auto flex-column" key="s_main">
          <div className={cx(css.header, css.mini, css.visible)}>
            <div className={css.header}>
              <div className={css.logoCircle} />

              <h1 className={css.heading}>{translate.i18n.PARTNERSHIPS.TITLE}</h1>
            </div>
          </div>
          <ScrollBar />
        </section>
        <section className="d-flex justify-content-center align-content-center mx-auto w-100 mb-5">
          <img alt="" className={css.wmax} src={euProjectPartnesLogo} />
        </section>
        <section className="d-flex flex-column justify-content-center mx-auto align-items-center">
          <h2 className={cx(css.title, 'mb-3 mt-3')}>
            {translate.i18n.PARTNERSHIPS.DOCUMENTS_TITLE}
          </h2>
          <div className="d-flex flex-column align-items-center">
            {translate.i18n.PARTNERSHIPS.DOCUMENTS.map((f) => (
              <a key={f.href} download className={css.fileLink} href={f.href}>
                <span>{f.title}</span>
                &nbsp;&nbsp;
                <Icon name="download" />
              </a>
            ))}
          </div>
        </section>
        <ScrollBar
          onLoadThreshold={90}
          onUnloadThreshold={10}
          onLoadChanged={setShouldAnimateFooter}
        />
      </div>
    </Layout>
  )
}
